import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  ViewChild,
} from '@angular/core';
import { IonContent, IonSelect } from '@ionic/angular';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-special-request',
  templateUrl: './special-request.page.html',
  styleUrls: ['./special-request.page.scss'],
})
export class SpecialRequestPage implements OnInit {
  @ViewChildren('groups') groups: QueryList<any>;
  @ViewChild('content') content: IonContent;
  private _domainId = environment.domainId;
  public fieldFormsDetail = undefined;
  public groupChoices = [];

  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices
  ) {}

  async ngOnInit() {
    await this.getForms();
    await this.getGroup();
  }

  async getForms() {
    try {
      const detailForm = await this.formSv.getForm(
        'specialRequests',
        this._domainId
      );
      this.fieldFormsDetail = detailForm;
    } catch (err) {
      console.error(err);
    }
  }

  async getGroup(ev?, group?, select?: IonSelect) {
    const choices: any[] = ev?.detail?.value || [];
    const fixedChoice =
      typeof choices === 'number' ? choices : choices.join(',');
    if (ev) {
      let canContinue = true;
      let msg = '';
      if (choices.length < group.min) {
        msg = `Debes seleccionar al menos ${group.min} opciones`;
        await this.uiSv.presentAlert(msg);
        canContinue = false;
      } else if (choices.length > group.max) {
        msg = `La selección máxima de opciones es de ${group.max}`;
        await this.uiSv.presentAlert(msg);
        await select.open();
        canContinue = false;
      }
      group.err = msg;
      if (!canContinue) return canContinue;
    }
    const params = {
      special: 1,
      domainId: this._domainId,
      group: group?.id,
      choices: fixedChoice || [],
    };
    const groups = await this.httpSv.itemIndex('groupChoices', '', params);
    const data: any[] = groups.data;
    const existGroup = this.groupChoices.findIndex(
      (group) =>
        group.name === data.find((data) => data.name === group.name)?.name
    );
    if (existGroup !== -1) {
      this.groupChoices[existGroup] = data[0];
    } else {
      this.groupChoices.push(...data);
    }
    this.groupChoices.forEach((x) => {
      if (!('count' in x)) {
        x.count = 0;
      }
    });
  }

  async sendData(ev: FormData) {
    try {
      const data = [];
      let existMin = false;
      for (const query of this.groups) {
        const groupId = Number(query.el.id);
        const body = {
          groupChoiceId: groupId,
          choiceId:
            typeof query.el.value === 'number'
              ? [query.el.value]
              : query.el.value || null,
        };
        const group = this.groupChoices.find((x) => x.id === groupId);
        const min = Number(query.el.name);
        if (
          min &&
          (body.choiceId < min || (body.choiceId && body.choiceId.length < min))
        ) {
          existMin = true;
          await this.uiSv.presentAlert(
            `${group.name} selección mínima: ${min}.`,
            false
          );
          break;
        }
        data.push(body);
      }

      if (existMin) return false;
      ev.set('domainId', environment.domainId.toString());
      ev.set('choices', JSON.stringify(data));
      // if(!this.loginSv.user){
      //   const okTxt = this.translateSv.instant('INICIA_SESION_O_REGISTRATE');
      //   const alertMsg = this.translateSv.instant('DEBES_INICIAR_SESION_ANTES_DE_REALIZAR_UNA_PETICION_ESPECIAL');
      //   await this.uiSv.presentAlert(alertMsg, false, okTxt, false);
      //   await this.navCtrl.navigateForward('auth', {queryParams: {sReq: '1'}});
      //   return false;
      // }
      await this.uiSv.showLoading();
      await this.httpSv.itemAction(ev, 'specialRequests', 'store');

      this.groupChoices = [];
      this.getGroup();
      this.formSv.clearFormSrc.next();
      this.content.scrollToTop(400);
      await this.uiSv.loading.dismiss();
    } catch (err) {
      console.error(err);
      await this.uiSv.loading.dismiss();
    }
  }
}
